<div *ngIf="running">
    <span *ngIf="!isPaused" class="status-label">{{ 'video_recording_timer_REC' | xsI18n }}</span>
    <span *ngIf="isPaused" class="status-label">{{ 'video_recording_timer_PAUSED' | xsI18n }}</span>
    <span *ngIf="!isPaused" class="hd-icon-recordingVideo"></span>
    <span *ngIf="isPaused" class="hd-icon-pauseVideo"></span>
    <span class="separator"></span>
    <span class="status-label time-label">
        {{formattedTime}}
    </span>
    <span class="separator"></span>
    <span *ngIf="isVideoWithAudio()" class="hd-icon-mic icon-md hd-recording-icon icon-recording-mic"></span>
    <span *ngIf="isVideoWithAudio()" class="hd-icon-plus icon-md hd-recording-icon icon-recording-plus"></span>
    <span class="hd-icon-recordVideo icon-md hd-recording-icon icon-recording-recordVideo"></span>
</div>